module.exports = __webpack_public_path__ + "img/nofeedback.7f2350cb.svg";